module.exports = __webpack_public_path__ + "static/media/matlab_logo.4b410fbc.png";